import _ from 'lodash'
import React, { Component } from 'react'
import styled from 'styled-components'
import qs from 'qs'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { displayVariations, updateComponentList } from '../../../actions/calculator'
import { device, ROOT_URL } from '../../../utils/helpers'
import CloseIcon from '../../UI/Icons/CloseIcon'
import CustomizeComponent from './CustomizeComponent'
import CustomizeOptions from './CustomizeOptions'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${device.tablet} {
    flex-direction: row;
  }
`

const Title = styled.div`
  background: #e2e2e2;
  padding: 20px 0;
  text-align: center;
  font-size: 24px;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;

  @media ${device.tablet} {
    padding: 1.0416666666666667vw 0;
    font-size: 1.875vw;
  }
`

const Image = styled.img`
  width: 100%;
  height: 200px;

  @media ${device.mobileMinM} {
    height: 275px;
  }

  @media ${device.mobileMinL} {
    height: 400px;
  }

  @media ${device.tablet} {
  ${''/* height: 590px; */}
    height: 28.645833333333336vw;
    position: absolute;
    opacity: ${props => props.opacity ? '0.2' : '1'};
  }
`

const Config = styled.div`
  background: #f3f3f3;
  padding-top: 20px;
  text-align: center;

  @media ${device.tablet} {
  ${''/* width: 140px; */}
    width: 18.229166666666668vw;
    padding-top: 1.0416666666666667vw;
  }

  @media ${device.laptopM} {
    ${''/* width: 340px; */}
    width: 17.708333333333336vw;
  }

  ${'' /* @media ${device.laptop} {
    width: 200px;
  }

  @media ${device.laptopM} {
    width: 250px;
  }

  @media ${device.laptopL} {
    width: 320px;
  }

  @media (min-width: 1770px) {
    width: 330px;
  } */}
`

const Customize = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 15px;
`

const Preview = styled.div`
  background: #e2e2e2;

  @media ${device.tablet} {
  ${''/* width: 380px; */}
    width: 49.47916666666667vw;
  }

  @media ${device.laptopM} {
  ${''/* width: 940px; */}
    width: 48.958333333333336vw;
  }

  ${'' /* @media ${device.laptop} {
    width: 440px;
  }

  @media ${device.laptopM} {
    width: 500px;
  }

  @media ${device.laptopL} {
    width: 660px;
  }

  @media (min-width: 1770px) {
    width: 950px;
  } */}
`

const PreviewImage = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  justify-content: center;
`

const PreviewOverlay = styled.div`
  width: ${props => props.width};
  height: auto;
  position: absolute;
  display: none;

  @media ${device.tablet} {
  ${''/* margin-top: 20px; */}
    margin-top: 0.516666666666667vw;
    display: block;
  }
`

const ConfigTitle = styled.div`
  padding: 0 10px;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  font-size: 24px;

  @media ${device.tablet} {
    font-size: 1.875vw;
  }
`

const Close = styled(CloseIcon)`
  position: absolute;
  top: 3px;
  right: 3px;
  display: none;
  cursor: pointer;

  @media ${device.tablet} {
    display: block;
  }
`

const CustomizeOptionsMobile = styled(CustomizeOptions)`

  @media ${device.tablet} {
    display: none;
  }
`

let Configurator = class Configurator extends Component {
  constructor (props) {
    super(props)
    this.state = {
      imgBit: 1
    }
  }

  componentDidMount () {
    const { step3Components, step4Components } = this.props
    const components = [...step3Components, ...step4Components]
    // Get the img bit for the URL of image by
    // bitwise ORing each config_bit
    const imgBit = _.reduce(components,
      (result, component) => {
        if (component.selected) {
          return result | component.config_bit
        } else {
          return result
        }
      },
      0)
    this.setState({ imgBit })
  }

  componentDidUpdate (prevProps, prevState) {
    const { step3Components, step4Components } = this.props
    const components = [...step3Components, ...step4Components]
    console.log(components)
    // Get the img bit for the URL of image by
    // bitwise ORing each config_bit
    const imgBit = _.reduce(components,
      (result, component) => {
        console.log(result)
        console.log(component)
        if (component.selected) {
          return result | component.config_bit
        } else {
          return result
        }
      },
      0)
    // Check if the newly calculated config_bit
    // is different from the previous one
    console.log(prevState.imgBit)
    console.log(imgBit)
    if (prevState.imgBit !== imgBit) {
      console.log(imgBit)
      this.setState({ imgBit })
    }
  }

  handleCloseClick () {
    // Blank array is set
    this.props.displayVariations()

    // To clear it for mobile
    let { components } = this.props
    let updatedComponents = components.filter(component => component.type !== 5)
    this.props.updateComponentList(updatedComponents)
  }

  render () {
    const { components, options, step } = this.props
    const { pathname } = this.props.location
    const currentVariant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    return (
      <Wrapper>
        <Preview>
          <Title>
            Il Tuo Campo
          </Title>
          <PreviewImage>
            <Image src={`${ROOT_URL}/variants/${currentVariant}/images/${this.state.imgBit}`} opacity={!!options.length || undefined} />
            {options.length > 0 &&
              <React.Fragment>
                <Close
                  width='15'
                  fill='#fff'
                  onClick={this.handleCloseClick.bind(this)}
                />
                <PreviewOverlay width={options.length === 2 ? '65%' : '95%'}>
                  <CustomizeOptions options={options} step={step} />
                </PreviewOverlay>
              </React.Fragment>
            }
          </PreviewImage>
        </Preview>
        <Config>
          {/* Show title according to step number */}
          <ConfigTitle>{pathname.includes('3') ? 'Personalizza' : 'Aggiungi Extra'}</ConfigTitle>
          <Customize>
            {components.map((component, i) => {
              if (component.type !== 5) {
                return (
                  <CustomizeComponent
                    key={i}
                    component={component}
                    name={component.name}
                    type={component.type}
                    details={component.details} // If details exists or not
                    step={step}
                  />
                )
              } else {
                return (
                  <CustomizeOptionsMobile key={i} options={options} step={step} />
                )
              }
            })}
            {/* Doing array of 10 - components length to create blank boxes */}
            {[...Array(10 - components.length)].map((_, i) => <CustomizeComponent key={i} type={0} />)}
          </Customize>
        </Config>
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  return {
    options: state.calculator.options,
    components: state.calculator.components,
    step3Components: state.calculator.steps[2].components,
    step4Components: state.calculator.steps[3].components
  }
}

Configurator = withRouter(Configurator)

export default connect(mapStateToProps, { displayVariations, updateComponentList })(Configurator)



// WEBPACK FOOTER //
// ./src/components/Calculator/Configurator/index.js